import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
type IconWrapperProps = {
  color: string
}
export const IconWrapper = styled.div<IconWrapperProps>`
  height: 64px;
  width: 64px;
  border-radius: 64px;
  background-color: ${({ color }) => color};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px;
`
